var __TEMP__ = require('./_LazyWrapper.js');var LazyWrapper = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getData.js');var getData = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./_getFuncName.js');var getFuncName = __REQUIRE_DEFAULT__(__TEMP__);
var __TEMP__ = require('./wrapperLodash.js');var lodash = __REQUIRE_DEFAULT__(__TEMP__);

/**
 * Checks if `func` has a lazy counterpart.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
 *  else `false`.
 */
function isLaziable(func) {
  var funcName = getFuncName(func),
      other = lodash[funcName];

  if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
    return false;
  }
  if (func === other) {
    return true;
  }
  var data = getData(other);
  return !!data && func === data[0];
}

if (!exports.__esModule) Object.defineProperty(exports, "__esModule", { value: true });exports.default = isLaziable;
